<template>
    <Tabs
        v-if="id"
        ref="Tabs"
        :form="form"
        :model="model"
    />

    <Wizard
        v-else
        ref="Wizard"
        :form="form"
        :model="model"
        @form-change="synchronizeCidadaoSearchData"
        @exit-busca="loadCidadaoData"
        @finish="save"
    />
</template>

<script>
// Components.
import Tabs from './Tabs'
import Wizard from './Wizard'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { cadastroCidadaoForm, repository, error, stringCase, object } from '@/mixins'

export default {
    components: { Tabs, Wizard },
    mixins: [ cadastroCidadaoForm, repository, error, stringCase, object ],
    props: {
        id: { type: Number }
    },
    data: () => ({
        repositories: {
            usuario: null,
        },
        form: {
            termosInvalidos: [],
            dataAtual: '',
            documentos: {
                conselhoProfissional: {
                    tiposRegistro: [],
                    estados: [],
                },
            },
            lotacao: {
                unidades: [],
            }
        },
        model: {
            id: null,
            documentos: {
                conselhoProfissional: {
                    registroTipoId: null,
                    registroTipoOutro: '',
                    registroNumero: '',
                    registroEstadoId: null,
                }
            },
            lotacoes: [],
            email: '',
            usuario: '',
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.usuario.edit(this.id)
                : this.repositories.usuario.create()

            request
                .then(({ data }) => this.setData(data.form, data.model || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {

            if (form.cidadao) {

                this.setCidadaoData(form.cidadao, model ? model.cidadao : null)
            }

            this.form.termosInvalidos = form.termosInvalidos
            this.form.isPermissaoEndereco = form.isPermissaoEndereco
            this.form.dataAtual = form.dataAtual

            Object.assign(
                this.form.documentos.conselhoProfissional,
                form.documentos.conselhoProfissional
            )

            Object.assign(this.form.lotacao, form.lotacao)

            if (model) {

                this.model.id = this.id

                Object.assign(
                    this.model.documentos.conselhoProfissional,
                    model.documentos.conselhoProfissional
                )

                this.model.lotacoes = model.lotacoes
                this.model.email = model.email
                this.model.usuario = model.usuario
            }
        },
        save() {

            this.$refs[this.id ? 'Tabs' : 'Wizard'].validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.usuario.update(this.id, this.prepareData())
                        : this.repositories.usuario.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const usuario = this.clone(this.model)

            delete usuario.id

            usuario.lotacoes = usuario.lotacoes.map(lotacao => ({
                id: isNaN(lotacao.id) ? null : lotacao.id,
                infraestruturaId: lotacao.infraestruturaId,
                ocupacaoId: lotacao.ocupacao.id,
                realizaAtendimento: lotacao.realizaAtendimento,
                ativo: lotacao.ativo,
            }))

            usuario.cidadao = this.prepareCidadaoData()

            return this.camelObjectKeysToSnakeRecursive(usuario)
        },
    },
    created() {

        this.repositories.usuario = this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario')

        this.load()
    },
}
</script>